// import { apiSlice } from '../api/apiSlice'
// import 

import { id } from "date-fns/locale";
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const REPACKING_ORDERS_BASE = "/repackingorders";
const buildUrl = (endpoint) => REPACKING_ORDERS_BASE + endpoint;

const repackingOrdersApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        createRepackingOrder: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/new`),
                method: 'POST',
                body,
                // headers: {
                //     "from_app":true
                // }
            }),
            providesTags: () => [{ type: 'Batches' }],
        }),
       
    })
});

export const {
    useCreateRepackingOrderMutation
  } = repackingOrdersApiSlice;
